<app-tab-menu>
	<div class="right-buttons">
		@if (datasnapUrlService.resultsForCurrentUrl$ | async; as datasnapResults) {
			@if (datasnapResults.length) {
				<span class="snapshot-title" (click)="openHistory(datasnapResults)">{{ snapshotTitle() | async }}</span>
				<app-icon
					class="tab-button history-icon"
					name="history"
					size="xlarge"
					[class.active]="datasnapUrlService.isViewingSnapshot()"
					[color]="datasnapUrlService.isViewingSnapshot() ? 'warning-1' : 'primary-1'"
					(click)="openHistory(datasnapResults)"
				></app-icon>
			}
		}
		@if (shareVisible) {
			<app-button class="tab-button" icon="share" buttonType="secondary" [lowerHeight]="true" (clickit)="sharePagina()">Delen</app-button>
		}
		@if (exportVisible) {
			<app-button
				class="tab-button"
				[icon]="showExportSpinner() ? undefined : 'export'"
				buttonType="primary"
				[lowerHeight]="true"
				(clickit)="exportClicked.emit()"
				[enabled]="!showExportSpinner()"
			>
				@if (showExportSpinner()) {
					<app-css-spinner></app-css-spinner>
				}
				Export
			</app-button>
		}
	</div>
</app-tab-menu>
